import script from "./BenchmarkTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenchmarkTable.vue?vue&type=script&setup=true&lang=ts"

import "./BenchmarkTable.vue?vue&type=style&index=0&id=4578e8d3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4578e8d3"]])

export default __exports__